import toaster from '@/toaster';
import { Button, Form, Input } from 'antd';
import { join, size } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import usePos from '../../hooks/auth/usePos';
import { RootState } from '../../redux/store';

interface PosFormProps {
  defaultName: string;
  onSubmit?: () => void;
}

const PosForm = ({ defaultName, onSubmit }: PosFormProps) => {
  const { isPending, createPos } = usePos();
  const { t } = useTranslation();
  const [name, setName] = useState(defaultName);
  const activeStoreId = useSelector((state: RootState) => state.auth.user?.activeStore?._id);

  const handleCreatePos = () => {
    createPos({
      name: name,
      storeId: activeStoreId,
    })
      .catch((err) => {
        if (err.message === 'network_offline')
          return toaster.error(t('common:offline_mode_error_title'));
        if (size(err.errors) > 0) {
          return toaster.error(join(err.errors, ','));
        }
      })
      .finally(() => {
        onSubmit?.();
      });
  };

  return (
    <div className="px-4 gap-4 mt-2">
      <h3 className="capitalize text-sm font-medium leading-6 text-gray-900">
        {t('landing:pos_creation_desc')}
      </h3>
      <Form layout="vertical">
        <Form.Item label={t('landing:pos_name')} className="!text-gray-500 dark:!text-gray-400">
          <Input
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="border border-gray-200 dark:border-gray-700 rounded-md"
            placeholder={t('landing:pos_name')}
          />
        </Form.Item>
      </Form>
      <Button
        type="primary"
        onClick={handleCreatePos}
        disabled={!name}
        loading={isPending}
        className="w-full"
      >
        {t('common:btn_send_title')}
      </Button>
    </div>
  );
};

export default PosForm;
